import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const UserMaleIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M8 1.33325C5.05467 1.33325 2.66667 3.72125 2.66667 6.66658V7.33325V7.93481C2.28419 8.29953 2 8.76868 2 9.33325C2 10.1612 2.5717 10.7752 3.29557 11.0754C4.16293 13.1486 5.90016 14.6666 8 14.6666C10.0998 14.6666 11.8371 13.1486 12.7044 11.0754C13.4283 10.7752 14 10.1612 14 9.33325C14 8.76868 13.7158 8.29953 13.3333 7.93481V7.33325V6.66658C13.3333 3.72125 10.9453 1.33325 8 1.33325ZM4.66667 6.66658H11.3333C11.7013 6.66658 12 6.96525 12 7.33325V7.99992V8.18091C12 8.29819 12.0309 8.4134 12.0897 8.5149C12.1484 8.6164 12.2329 8.70061 12.3346 8.75903C12.5371 8.87523 12.6667 9.07659 12.6667 9.33325C12.6667 9.67667 12.4208 9.94173 12.0924 9.9869C11.974 10.003 11.8621 10.0507 11.7684 10.1249C11.6747 10.1991 11.6027 10.2972 11.5599 10.4088C10.8727 12.1996 9.50563 13.3333 8 13.3333C6.49437 13.3333 5.12731 12.1996 4.4401 10.4088C4.3973 10.2972 4.32529 10.1991 4.23159 10.1249C4.1379 10.0507 4.02598 10.003 3.90755 9.9869C3.57922 9.94173 3.33333 9.67667 3.33333 9.33325C3.33333 9.07659 3.46294 8.87523 3.66536 8.75903C3.76706 8.70061 3.85155 8.6164 3.91031 8.5149C3.96906 8.4134 4 8.29819 4 8.18091V7.99992V7.33325C4 6.96525 4.29867 6.66658 4.66667 6.66658Z"
      fill={props.sx?.color || '#3266F5'}
    />
  </SvgIcon>
);

UserMaleIcon.propTypes = {
  sx: PropTypes.object,
};

export default UserMaleIcon;
